import React, { useState, useRef, useEffect } from "react";
import logo from "../Assets/kalam_kids_best_kindergarten_logo.png";
import Select from "react-tailwindcss-select";
import { MultiSelect } from "react-multi-select-component";
import ReactSignatureCanvas from "react-signature-canvas";
import { MdCheckCircle, MdError } from "react-icons/md";
import { db } from "../firebase";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import { createForm, getFormById, updateForm } from "../api/Api";
import { generateAcademicYears } from "../utils/academicYearUtils";
const Form = ({item,onclose}) => {
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [dialog, setDialog] = useState({
    type: "", // "success" or "error"
    message: "",
    show: false,
  }); 
  const [formData, setFormData] = useState({
    dateOfAdmission: "",
    admissionFor: "",
    academicYear: "",
    particularsOfChild: {
      fullName: "",
      surname: "",
      nameUsedAtHome: "",
      nationality: "",
      dob: "",
      gender: "",
      language: "",
      otherLanguage: "",
      age: "",
      blood:"",

      houseNo: "",
      buildingName: "",
      streetName: "",
      city: "",
      pincode: "", // Age field
    },
    particularsOfParents: {
      FatherName: "",
      FatherQualification: "",
      FatherOccupation: "",
      FatherOrganisationName: "",
      FatherSTDCodeRes: "",
      FatherTelRes: "",
      FatherSTDCodeOff: "",
      FatherTelOff: "",
      FatherMobile: "",
      FatherEmail: "",
      MotherName: "",
      MotherQualification: "",
      MotherOccupation: "",
      MotherOrganisationName: "",
      MotherSTDCodeRes: "",
      MotherTelRes: "",
      MotherSTDCodeOff: "",
      MotherTelOff: "",
      MotherMobile: "",
      MotherEmail: "",
    },
    childPersonalBackground: {
      characteristics: [],
      PreviousSchooling: "",
      PreviousSchoolingDetails: "",
      Toilettrained: "",
      Siblings: {
        Brothers: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
        Sisters: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
      },
      PreviousKalamKidsDetails: "",
      PreviousKalamKids: "",
      suffered: "",
      surgery: "",
      allergy: "",
      phobias: "",
      phobiasDetails: "",
      medication: "",
      medicationDetails: "",
    },
    // Add medicalRecord for vaccinations
    medicalRecord: {
      BCG: "",
      "DPT (I, II, III)": "",
      "Oral Polio vaccine (OPV)": "",
      Measles: "",
      MMR: "",
      DT: "",
      "HBV-Hepatitis (I, II, III)": "",
      "Hi B (Meningitis-3 doses)": "",
      Chickenpox: "",
      Typhoid: "",
      "Hepatitis A (2 doses)": "",
    },
    Declarationparent: {
      signatureRef: "",
      date: "",
      acknowledgmentName: "",
      acknowledgmentSignatureRef: "",
      volunteerJob: false,
      specialEventsCost: false,
      attendMeetings: false,
    },
  });
  const signatureRef = useRef(null);
  const [isViewMode, setIsViewMode] = useState(false); 
  const acknowledgmentSignatureRef = useRef(null);
  const [loading, setLoading] = useState(false); 
  const userRole = localStorage.getItem("role");

  const navigate = useNavigate();
  const options = ["Day Care","Play Group", "Pre KG", "LKG", "UKG"];
  const steps = [
    "Particulars of the Child",
    "Particulars of Parents / Guardian",
    "Child’s Personal Background",
    "Medical Record",
    "Declaration ",
  
    
    // "Acknowledgment of Paranetal Responsib",
  ];
  const characteristics = [
    "Aggressive",
    "Friendly",
    "Moody",
    "Clumsy",
    "Dependent",
    "Fearful",
    "Quiet",
    "Good-natured",
    "Even-tempered",
    "Impulsive",
    "Shy",
    "Sympathetic",
    "Stubborn",
    "Attentive",
  ];
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);

  const handleChange = (selectedOptions) => {
    const updatedCharacteristics = selectedOptions.map((option) => option.value);
    console.log("Updated Characteristics:", updatedCharacteristics); // Debugging line
    setFormData((prevData) => ({
      ...prevData,
      childPersonalBackground: {
        ...prevData.childPersonalBackground,
        characteristics: updatedCharacteristics,
      },
    }));
  };
  
  
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0); // Scroll to the top of the page
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0); // Optional: Scroll to the top when going back
    }
  };
  const showDialog = (type, message) => {
    setDialog({ type, message, show: true });
// Automatically close dialog after 3 seconds
    setTimeout(() => {
      setDialog({ ...dialog, show: false });
    }, 4000);
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true);

  try {
    let parentSignature =
      formData.Declarationparent?.signatureRef || "";

    let acknowledgmentSignature =
      formData.Declarationparent?.acknowledgmentSignatureRef || "";

    // NEW FORM
    if (!isViewMode) {
      if (
        !signatureRef.current ||
        !acknowledgmentSignatureRef.current
      ) {
        throw new Error("Signature canvas is not initialized.");
      }

      parentSignature = signatureRef.current.toDataURL();

      acknowledgmentSignature =
        acknowledgmentSignatureRef.current.toDataURL();
    }

    // IMPORTANT
    console.log("test",item)
    const updatedFormData = {
      ...formData,

      // ADD THIS
      branch:
        localStorage.getItem("selectedBranchId" ) ||
        item?.branch ||
        "",
        

     academicYear: formData.academicYear,
      Declarationparent: {
        ...formData.Declarationparent,
        signatureRef: parentSignature,
        acknowledgmentSignatureRef:
          acknowledgmentSignature,
      },
    };

    console.log("SUBMIT DATA :", updatedFormData);

    let response;

    if (isViewMode) {
      response = await updateForm(id, updatedFormData);
    } else {
      response = await createForm(updatedFormData);
    }

    if (response.success) {
      showDialog(
        "success",
        isViewMode
          ? "Form updated successfully!"
          : "Form submitted successfully!"
      );

      if (!isViewMode) {
        resetFormData();

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        setTimeout(() => {
          fetchData();
        }, 2000);
      }
    } else {
      throw new Error(
        response.message || "Failed to submit form"
      );
    }
  } catch (error) {
    console.error("Submit Error:", error);

    showDialog(
      "error",
      error.message || "Something went wrong"
    );
  } finally {
    setLoading(false);
  }
};



// Function to reset form data
const resetFormData = () => {
  setFormData({
    dateOfAdmission: "",
    admissionFor: "",
    particularsOfChild: {
      fullName: "",
      surname: "",
      nameUsedAtHome: "",
      nationality: "",
      dob: "",
      gender: "",
      language: "",
      otherLanguage: "",
      age: "",
      blood: "",
      houseNo: "",
      buildingName: "",
      streetName: "",
      city: "",
      pincode: "",
    },
    particularsOfParents: {
      FatherName: "",
      FatherQualification: "",
      FatherOccupation: "",
      FatherOrganisationName: "",
      FatherSTDCodeRes: "",
      FatherTelRes: "",
      FatherSTDCodeOff: "",
      FatherTelOff: "",
      FatherMobile: "",
      FatherEmail: "",
      MotherName: "",
      MotherQualification: "",
      MotherOccupation: "",
      MotherOrganisationName: "",
      MotherSTDCodeRes: "",
      MotherTelRes: "",
      MotherSTDCodeOff: "",
      MotherTelOff: "",
      MotherMobile: "",
      MotherEmail: "",
    },
    childPersonalBackground: {
      characteristics: [],
      PreviousSchooling: "",
      PreviousSchoolingDetails: "",
      Toilettrained: "",
      Siblings: {
        Brothers: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
        Sisters: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
      },
      PreviousKalamKidsDetails: "",
      PreviousKalamKids: "",
      suffered: "",
      surgery: "",
      allergy: "",
      phobias: "",
      phobiasDetails: "",
      medication: "",
      medicationDetails: "",
    },
    medicalRecord: {
      BCG: "",
      "DPT (I, II, III)": "",
      "Oral Polio vaccine (OPV)": "",
      Measles: "",
      MMR: "",
      DT: "",
      "HBV-Hepatitis (I, II, III)": "",
      "Hi B (Meningitis-3 doses)": "",
      Chickenpox: "",
      Typhoid: "",
      "Hepatitis A (2 doses)": "",
    },
    Declarationparent: {
      signatureRef: "",
      date: "",
      acknowledgmentName: "",
      acknowledgmentSignatureRef: "",
      volunteerJob: false,
      specialEventsCost: false,
      attendMeetings: false,
    },
  });
};
  // const uploadSignatureToFirebase = async (signatureCanvasRef, fieldName) => {
  //   const signatureData = signatureCanvasRef.current.toDataURL(); // Get the signature as a Base64 image

  //   // Create a storage reference
  //   const storageRef = firebase.storage().ref();
  //   const signatureRef = storageRef.child(`signatures/${fieldName}_${Date.now()}.png`);

  //   // Upload the Base64 image to Firebase
  //   try {
  //     await signatureRef.putString(signatureData, 'data_url');
  //     const signatureUrl = await signatureRef.getDownloadURL(); // Get the URL of the uploaded image
  //     console.log("Signature uploaded successfully: ", signatureUrl);
  //     return signatureUrl;
  //   } catch (error) {
  //     console.error("Error uploading signature: ", error);
  //     return null;
  //   }
  // };

  //   const handleInputChange = (section, field, value) => {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [section]: {
  //         ...prevData[section],
  //         [field]: value,
  //       },
  //     }));
  //   };
  const handleInputChange = (field, subField, value) => {
    setFormData((prev) => {
      const keys = subField.split(".");
      
      const updateDeep = (obj, path, val) => {
        const [first, ...rest] = path;
        if (!rest || rest.length === 0) {
          return { ...obj, [first]: val };
        }
        return {
          ...obj,
          [first]: updateDeep(obj[first] || {}, rest, val)
        };
      };

      return {
        ...prev,
        [field]: updateDeep(prev[field] || {}, keys, value)
      };
    });
  };
  
  

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  // Adjust if the current month is before the birth month
  if (months < 0) {
    years--;
    months += 12;
  }
  return { years, months }; // Return an object with years and months
};
const handleDobChange = (e) => {
  const dob = e.target.value;
  handleInputChange("particularsOfChild", "dob", dob);
  // Calculate the age
  const { years, months } = calculateAge(dob);
  handleInputChange("particularsOfChild", "age", `${years} years ${months} months`); // Set age in the desired format
};
  const handleVaccinationChange = (vaccine, option) => {
    setFormData((prevData) => ({
      ...prevData,
      medicalRecord: {
        ...prevData.medicalRecord,
        [vaccine]: option, // Update the selected vaccine with the chosen option
      },
    }));
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div>
  <h2 className="text-[#16bab1]xl font-semibold mb-4">
    Particulars of the Child
  </h2>

  {/* Form Fields */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {/* Full Name */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Full Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.fullName}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "fullName",
            e.target.value
          )
        }
      />
    </div>

    {/* Surname */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Surname:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.surname}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "surname",
            e.target.value
          )
        }
      />
    </div>

    {/* Name Used at Home */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Name Used at Home:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.nameUsedAtHome}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "nameUsedAtHome",
            e.target.value
          )
        }
      />
    </div>

    {/* Nationality */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Nationality:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.nationality}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "nationality",
            e.target.value
          )
        }
      />
    </div>

    {/* Date of Birth */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Date of Birth:
      </label>
      <input
        type="date"
        value={formData.particularsOfChild?.dob}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={handleDobChange}
      />
    </div>

    {/* Age (Auto-calculated) */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Age:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.age}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "age",
            e.target.value
          )
        } // Allow manual edit
      />
    </div>
 {/* Blood Group Selection */}


    {/* Gender Selectionaa */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Gender:
      </label>
      <div className="flex gap-4 mt-2">
        {["Male", "Female"].map((option) => (
          <div
            key={option}
            onClick={() =>
              handleInputChange(
                "particularsOfChild",
                "gender",
                option
              )
            }
            className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
              formData.particularsOfChild?.gender === option
                ? "bg-[#16bab1] text-white"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {option}
          </div>
        ))}
      </div>
    </div>

    {/* House No. */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        House No.:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.houseNo || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "houseNo",
            e.target.value
          )
        }
      />
    </div>

    {/* Name of the Apartment/Building/House */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Apartment/Building Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.buildingName || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "buildingName",
            e.target.value
          )
        }
      />
    </div>

    {/* Street Name */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Street Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.streetName || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "streetName",
            e.target.value
          )
        }
      />
    </div>

    {/* Town/City */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Town/City:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.city || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "city",
            e.target.value
          )
        }
      />
    </div>

    {/* Pincode */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Pincode:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild?.pincode || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "pincode",
            e.target.value
          )
        }
      />
    </div>

    {/* Language(s) Spoken at Home */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Language(s) Spoken at Home
      </label>
      <div className="flex gap-4 mt-2">
        {["English", "Tamil", "Other"].map((option) => (
          <div
            key={option}
            onClick={() =>
              handleInputChange(
                "particularsOfChild",
                "language",
                option
              )
            }
            className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
              formData.particularsOfChild?.language === option
                ? "bg-[#16bab1] text-white"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {option}
          </div>
        ))}
      </div>

      {/* Conditionally render input field for "Other" */}
      {formData.particularsOfChild?.language === "Other" && (
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Please specify:
          </label>
          <input
            type="text"
            value={formData.particularsOfChild?.otherLanguage || ""}
            className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
            onChange={(e) =>
              handleInputChange(
                "particularsOfChild",
                "otherLanguage",
                e.target.value
              )
            }
          />
        </div>
      )}
    </div>
  </div>
</div>

        );
      case 1:
        return (
          <>
            <div className="mb-4">
              <h2 className="text-[#16bab1]xl font-semibold mb-4">Father / Guardian</h2>
              <div className="grid grid-cols-2 gap-4 items-start">
                {/* Name */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name:
                  </label>
                  <input
                    type="text"
                   placeholder="FatherName"

                    value={formData.particularsOfParents?.FatherName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Educational Qualification */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Educational Qualification:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Undergraduate", "Graduate", "Postgraduate"].map(
                      (option) => (
                        <div
                          key={option}
                          onClick={() =>
                            handleInputChange(
                              "particularsOfParents",
                              "FatherQualification",
                              option
                            )
                          }
                          className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                            formData.particularsOfParents
                              ?.FatherQualification === option
                              ? "bg-[#16bab1] text-white"
                              : "bg-white text-gray-700 border-gray-300"
                          }`}
                        >
                          {option}
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Occupation */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Occupation:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Service", "Business", "Public Service"].map((option) => (
                      <div
                        key={option}
                        onClick={() =>
                          handleInputChange(
                            "particularsOfParents",
                            "FatherOccupation",
                            option
                          )
                        }
                        className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                          formData.particularsOfParents?.FatherOccupation ===
                          option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                        }`}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Name of the Organisation */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name of the Organisation:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents?.FatherOrganisationName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherOrganisationName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Tel No. */}
                <div className="col-span-4 lg:col-span-2">
      <label className="block text-sm font-medium text-gray-700">
        Tel No.:
      </label>
      <div className="grid grid-cols-4 gap-2 mt-2">
        <input
          type="text"
          placeholder="[STD]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherSTDCodeRes || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherSTDCodeRes",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[Res]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherTelRes || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherTelRes",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[STD]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherSTDCodeOff || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherSTDCodeOff",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[Off]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherTelOff || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherTelOff",
              e.target.value
            )
          }
        />
      </div>
    </div>

    {/* Mobile */}
    <div className="col-span-4 lg:col-span-1">
      <label className="block text-sm font-medium text-gray-700">
        Mobile:
      </label>
      <input
        type="text"
        placeholder="[Mob]"
        className="mt-2 px-4 py-2 border border-gray-300 rounded-md w-full"
        value={formData?.particularsOfParents?.FatherMobile || ""}
        onChange={(e) =>
          handleInputChange(
            "particularsOfParents",
            "FatherMobile",
            e.target.value
          )
        }
      />
    </div>


                {/* Email Address */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Email Address:
                  </label>
                  <input
                    type="email"
                    placeholder="@gmail.com"
                    value={formData.particularsOfParents?.FatherEmail}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherEmail",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div>
              <h2 className="text-[#16bab1]xl font-semibold mb-4">Mother / Guardian</h2>
              <div className="grid grid-cols-2 gap-4 items-start">
                {/* Name */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents?.MotherName}
                    placeholder="MotherName"

                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Educational Qualification */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Educational Qualification:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Undergraduate", "Graduate", "Postgraduate"].map(
                      (option) => (
                        <div
                          key={option}
                          onClick={() =>
                            handleInputChange(
                              "particularsOfParents",
                              "MotherQualification",
                              option
                            )
                          }
                          className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                            formData.particularsOfParents
                              ?.MotherQualification === option
                              ? "bg-[#16bab1] text-white"
                              : "bg-white text-gray-700 border-gray-300"
                          }`}
                        >
                          {option}
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Occupation */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Occupation:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Service", "Business", "Public Service"].map((option) => (
                      <div
                        key={option}
                        onClick={() =>
                          handleInputChange(
                            "particularsOfParents",
                            "MotherOccupation",
                            option
                          )
                        }
                        className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                          formData.particularsOfParents?.MotherOccupation ===
                          option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                        }`}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Name of the Organisation */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name of the Organisation:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents?.MotherOrganisationName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherOrganisationName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Tel No. */}
                <div className="col-span-4 lg:col-span-2">
  <label className="block text-sm font-medium text-gray-700">
    Tel No.:
  </label>
  <div className="grid grid-cols-4 gap-2 mt-2">
    {/* STD Code for Residential */}
    <input
      type="text"
      placeholder="[STD]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherSTDCodeRes || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherSTDCodeRes",
          e.target.value
        )
      }
    />
    {/* Residential Tel No */}
    <input
      type="text"
      placeholder="[Res]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherTelRes || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherTelRes",
          e.target.value
        )
      }
    />
    {/* STD Code for Office */}
    <input
      type="text"
      placeholder="[STD]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherSTDCodeOff || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherSTDCodeOff",
          e.target.value
        )
      }
    />
    {/* Office Tel No */}
    <input
      type="text"
      placeholder="[Off]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherTelOff || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherTelOff",
          e.target.value
        )
      }
    />
  </div>
</div>

{/* Mobile */}
<div className="col-span-4 lg:col-span-1">
  <label className="block text-sm font-medium text-gray-700">
    Mobile:
  </label>
  <input
    type="text"
    placeholder="[Mob]"
    className="mt-2 px-4 py-2 border border-gray-300 rounded-md w-full"
    value={formData?.particularsOfParents?.MotherMobile || ""}
    onChange={(e) =>
      handleInputChange(
        "particularsOfParents",
        "MotherMobile",
        e.target.value
      )
    }
  />
</div>


                {/* Email Address */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Email Address:
                  </label>
                  <input 
                    type="email"
                    placeholder="@gmail.com"

                    value={formData.particularsOfParents?.MotherEmail}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherEmail",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
  {/* Full width MultiSelect component */}
  <div className="col-span-3">
    <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="characteristics">
      Please select the characteristics that generally describe your child:
    </label>
    <MultiSelect
  options={characteristics.map((characteristic) => ({
    label: characteristic,
    value: characteristic,
  }))}
  value={formData.childPersonalBackground.characteristics.map((characteristic) => ({
    label: characteristic,
    value: characteristic,

  }))}
  onChange={handleChange}
  labelledBy="Select Characteristics"
  className="bg-white border border-gray-300 rounded-lg shadow-sm w-full p-3 focus:outline-none focus:ring-2 focus:ring-[#e84c24]"
/>


  </div>

  {/* Previous Schooling */}
  <div className="mb-4 md:col-span-1 col-span-2">
    <label className="block text-sm font-medium text-gray-700">
      Previous Schooling
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <button
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "PreviousSchooling", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground?.PreviousSchooling === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  </div>

  {/* If "Yes", show the details input for Previous Schooling */}
  {formData.childPersonalBackground?.PreviousSchooling === "Yes" && (
    <div className="mb-4 md:col-span-1 col-span-2">
      <label className="block text-sm font-medium text-gray-700">
        If yes, please specify:
      </label>
      <input
        type="text"
        value={formData.childPersonalBackground?.PreviousSchoolingDetails}
        onChange={(e) =>
          handleInputChange("childPersonalBackground", "PreviousSchoolingDetails", e.target.value)
        }
        className="mt-2 px-4 py-2 w-full border border-gray-300 rounded-md"
        placeholder="Enter details"
      />
    </div>
  )}

  {/* Toilet trained question */}
  <div className="mb-4 md:col-span-1 col-span-2">
    <label className="block text-sm font-medium text-gray-700">
      • Is your child Toilet trained?
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <div
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "Toilettrained", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground?.Toilettrained === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </div>
      ))}
    </div>
  </div>

  {/* Siblings Information */}
  <div className="col-span-3 gap-4">
    <label className="block text-sm font-medium text-gray-700">
      • How many siblings does the child have?
    </label>

    <div className="col-span-3">
      <label className="block text-sm font-medium text-gray-700">
        Brothers (mention age):
      </label>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`brother-${index}`} className="flex gap-4 mt-2">
          <input
            type="text"
            value={formData.childPersonalBackground?.Siblings?.Brothers[index]?.name || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Brothers.${index}.name`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Brother ${index + 1} Name`}
          />
          <input
            type="text"
            value={formData.childPersonalBackground?.Siblings?.Brothers[index]?.age || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Brothers.${index}.age`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Brother ${index + 1} Age`}
          />
        </div>
      ))}
    </div>

    <div className="col-span-3 mt-4">
      <label className="block text-sm font-medium text-gray-700">
        Sisters (mention age):
      </label>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`sister-${index}`} className="flex gap-4 mt-2">
          <input
            type="text"
            value={formData.childPersonalBackground?.Siblings?.Sisters[index]?.name || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Sisters.${index}.name`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Sister ${index + 1} Name`}
          />
          <input
            type="text"
            value={formData.childPersonalBackground?.Siblings?.Sisters[index]?.age || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Sisters.${index}.age`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Sister ${index + 1} Age`}
          />
        </div>
      ))}
    </div>
  </div>

  {/* Has any of the child’s kin attended Kalam Kids before */}
  <div className="mb-4 col-span-2">
    <label className="block text-sm font-medium text-gray-700">
      Has any of the child’s kin attended Kalam Kids before?
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <div
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "PreviousKalamKids", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground?.PreviousKalamKids === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </div>
      ))}
    </div>
  </div>
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700">
    Blood Group:
  </label>
  <select
    value={formData.particularsOfChild?.blood || ""}
    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
    onChange={(e) =>
      handleInputChange("particularsOfChild", "blood", e.target.value)
    }
  >
    <option value="" disabled>Select Blood Group</option>
    {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((bloodGroup) => (
      <option key={bloodGroup} value={bloodGroup}>
        {bloodGroup}
      </option>
    ))}
  </select>
</div>
  {/* If "Yes", show the details input for Previous Kalam Kids */}
  {formData.childPersonalBackground?.PreviousKalamKids === "Yes" && (
    <div className="mb-4 col-span-3">
      <label className="block text-sm font-medium text-gray-700">
        If yes, which year:
      </label>
      <input
        type="text"
        value={formData.childPersonalBackground?.PreviousKalamKidsDetails}
        onChange={(e) =>
          handleInputChange("childPersonalBackground", "PreviousKalamKidsDetails", e.target.value)
        }
        className="mt-2 px-4 py-2 w-full border border-gray-300 rounded-md"
        placeholder="Enter details"
      />
    </div>
  )}
</div>

        
        );
      case 3:
        return (
          <div>
          <h2>Vaccination Details</h2>
          <div className="overflow-x-auto mt-4">
            <table className="min-w-full table-auto border-collapse border border-gray-300">
              <thead>
                <tr className="bg-[#16bab1] text-white font-semibold">
                  <th className="px-4 py-2 border text-left">S.No.</th>
                  <th className="px-4 py-2 border text-left">Vaccination</th>
                  <th className="px-4 py-2 border text-left">Age</th>
                  <th className="px-4 py-2 border text-[#16bab1]enter">Yes / No</th>
                </tr>
              </thead>
              <tbody className="font-medium">
  {[
    { vaccine: "BCG", age: "0-2 weeks" },
    { vaccine: "DPT (I, II, III)", age: "6-24 weeks" },
    { vaccine: "Oral Polio vaccine (OPV)", age: "6 doses" },
    { vaccine: "Measles", age: "8-9 months" },
    { vaccine: "MMR", age: "15-18 months" },
    { vaccine: "DT", age: "4-6 years" },
    { vaccine: "HBV-Hepatitis (I, II, III)", age: "Up to 24 months" },
    { vaccine: "Hi B (Meningitis-3 doses)", age: "Under 1 year" },
    { vaccine: "Chickenpox", age: "After 1 year of age" },
    { vaccine: "Typhoid", age: "After 2 years" },
    { vaccine: "Hepatitis A (2 doses)", age: "After 1 year of age" },
  ].map((vaccination, index) => (
    <tr key={index} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
      <td className="px-4 py-2 border text-[#16bab1]enter">{index + 1}</td>
      <td className="px-4 py-2 border">{vaccination?.vaccine}</td>
      <td className="px-4 py-2 border">{vaccination?.age}</td>
      <td className="px-4 py-2 border text-[#16bab1]enter">
        <div className="flex gap-4 justify-center">
          {["Yes", "No"].map((option) => (
            <div
              key={option}
              onClick={() =>
                handleVaccinationChange(vaccination?.vaccine, option)
              }
              className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-16 ${
                formData?.medicalRecord?.[vaccination?.vaccine] === option // Use optional chaining
                  ? "bg-[#16bab1] text-white"
                  : "bg-white text-gray-700 border-gray-300"
              }`}
            >
              {option}
            </div>
          ))}
        </div>
      </td>
    </tr>
  ))}
</tbody>
            </table>
          </div>
          <div className="mt-4 text-sm">
            <p>
              <strong className="text-black font-semibold">Note:</strong>
            </p>
            <ul className="list-disc list-inside ml-4 font-medium">
              <li className="text-gray-600">Vaccines (1) to (7) are compulsory.</li>
              <li className="text-gray-600">Vaccines (8) to (11) are optional but recommended.</li>
            </ul>
          </div>
        
          <div className="mt-6">
            <h3 className="text-lg font-medium text-gray-700">
              II. History of Past Illness
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
              {/* Specific Ailments */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Specific ailments suffered in the past:
                </label>
                <input
                  type="text"
                  value={formData.childPersonalBackground.suffered || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("childPersonalBackground", "suffered", e.target.value)
                  }
                />
              </div>
              {/* Surgery */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Surgery undergone (if any):
                </label>
                <input
                  type="text"
                  value={formData.childPersonalBackground?.surgery || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("childPersonalBackground", "surgery", e.target.value)
                  }
                />
              </div>
              {/* Allergy */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Allergy (if any):
                </label>
                <input
                  type="text"
                  value={formData.childPersonalBackground?.allergy || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("childPersonalBackground", "allergy", e.target.value)
                  }
                />
              </div>
            </div>
        
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700">
                Does your child suffer from any phobias?
              </label>
              <div className="flex gap-4 mt-2">
                {["Yes", "No"].map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      handleInputChange("childPersonalBackground", "phobias", option)
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.childPersonalBackground?.phobias === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
              {formData.medicalRecord.phobias === "Yes" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Please specify:
                  </label>
                  <input
                    type="text"
                    value={formData.childPersonalBackground?.phobiasDetails || ""}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange("childPersonalBackground", "phobiasDetails", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
        
            {/* Regular Medication */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700">
                Is the child presently on any regular medication?
              </label>
              <div className="flex gap-4 mt-2">
                {["Yes", "No"].map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      handleInputChange("childPersonalBackground", "medication", option)
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.childPersonalBackground?.medication === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
              {formData.medicalRecord.medication === "Yes" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Please specify:
                  </label>
                  <input
                    type="text"
                    value={formData.childPersonalBackground?.medicationDetails || ""}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange("childPersonalBackground", "medicationDetails", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        
        );
      case 4:
        return (
          <>
 
    <>
      <div className="max-w-6xl mx-auto bg-white p-8 rounded-lg shadow-md border border-[#16bab1]">
        {/* Declaration Section */}
        <h2 className="text-md p-1 py-2 font-semibold text-[#16bab1]enter bg-[#16bab1] text-white mb-4">
          Declaration of parent / Guardian
        </h2>
        <div className="mt-6">
          <p className="text-md font-medium text-gray-700 mb-6 leading-relaxed">
            I declare that the information given is correct and complete and I have not withheld any information. I agree to entrust my child under the care of the staff at{" "}
            <span className="font-semibold">Kalam Kids</span>. I am aware that the fee once paid is{" "}
            <span className="font-semibold">non-transferable</span> and <span className="font-semibold">non-refundable</span> under any circumstances. I have read through the{" "}
            <span className="font-semibold">Kalam Kids</span> pre-school policies and am in agreement with the said policies.
          </p>

          {/* Signature Field */}
   {/* Signature Field */}
<div className="mt-4">
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Parent's Signature:
  </label>
  {isViewMode ? (
    <img
      src={formData.Declarationparent?.signatureRef}
      alt="Parent's Signature"
      className="border border-gray-300 rounded-md"
      style={{ width: '100%', height: 'auto' }} // Adjust as needed
    />
  ) : (
    <div className="border border-gray-300 rounded-md overflow-hidden">
      <ReactSignatureCanvas
        penColor="black"
        canvasProps={{
          width: 1024,
          height: 150,
          className: "sigCanvas",
        }}
        ref={signatureRef}
      />
    </div>
  )}
  {!isViewMode && (
    <button
      className="mt-2 text-sm text-[#e84c24] underline hover:text-[#e84c24]"
      onClick={() => signatureRef?.current?.clear()}
      type="button"
    >
      Clear Signature
    </button>
  )}
</div>


          {/* Date Field */}
          <div className="mt-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date:
            </label>
            <input
              type="date"
              value={formData.Declarationparent?.date || ""}
              className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              onChange={(e) =>
                handleInputChange(
                  "Declarationparent",
                  "date",
                  e.target.value
                )
              }
              disabled={isViewMode} // Disable input in view mode
            />
          </div>
        </div>

        {/* Acknowledgment Section */}
        <div className="mt-8">
          <h2 className="text-md p-1 py-2 font-semibold text-[#16bab1]enter bg-[#16bab1] text-white mb-4">
            Acknowledgment of Parental Responsibility
          </h2>
          <p className="text-sm text-gray-600 mb-6 leading-relaxed">
            I,{" "}
            <input
              type="text"
              value={formData.Declarationparent?.acknowledgmentName || ""}
              onChange={(e) =>
                handleInputChange(
                  "Declarationparent",
                  "acknowledgmentName",
                  e.target.value
                )
              }
              className="border-b border-gray-400 focus:border-[#16bab1] px-2 py-1 outline-none"
              disabled={isViewMode} // Disable input in view mode
            />
            , hereby acknowledge that I understand the expectations to participate in the smooth running of my children’s Play School as follows:
          </p>
          <div className="text-sm text-gray-600 mb-6">
  <label className="block mb-4">
    <input
      type="checkbox"
      name="volunteerJob"
      className="mr-2"
      checked={formData.Declarationparent?.volunteerJob} // Bind the state value
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "volunteerJob",
          e.target.value
        )
      }
    />
    I am required to take at least one job from the Volunteer Job list and perform it to the best of my ability.
  </label>
  <label className="block mb-4">
    <input
      type="checkbox"
      name="specialEventsCost"
      className="mr-2"
      checked={formData.Declarationparent?.specialEventsCost}
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "specialEventsCost",
          e.target.value
        )
      }
    />
    I am required to pay for my children’s special events and field trip costs.
  </label>
  <label className="block mb-4">
    <input
      type="checkbox"
      name="attendMeetings"
      className="mr-2"
      checked={formData.Declarationparent?.attendMeetings}
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "attendMeetings",
          e.target.value
        )
      }
    />
    I am required to attend Annual General Meetings.
  </label>
</div>



          {/* Acknowledgment Signature Field */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Acknowledgment Signature:
            </label>
            {isViewMode ? (
              <img
                src={formData.Declarationparent?.acknowledgmentSignatureRef}
                alt="Acknowledgment Signature"
                className="border border-gray-300 rounded-md"
                style={{ width: '100%', height: 'auto' }} // Adjust as needed
              />
            ) : (
              <div className="border border-gray-300 rounded-md overflow-hidden">
                <ReactSignatureCanvas
                  penColor="black"
                  canvasProps={{
                    width: 1000,
                    height: 150,
                    className: "sigCanvas",
                  }}
                  ref={acknowledgmentSignatureRef}
                />
              </div>
            )}
            {!isViewMode && (
              <button
                className="mt-2 text-sm text-[#e84c24] underline hover:text-[#e84c24]"
                onClick={() => acknowledgmentSignatureRef?.current?.clear()}
                type="button"
              >
                Clear Signature
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  
          </>
        );

      default:
        return <div>Step not found</div>;
    }
  };
  const handleOverAllView = (id) => {
    navigate(`/pdf/${id}`); // Navigate to the Form component with the item ID
  };

  const fetchData = async () => {
    if (id) {
      setLoading(true); // Set loading to true before fetching data
      try {
        const response = await getFormById(id); // Fetch the data using Axios
        console.log("Fetched Data:", response); // Log the fetched data

        if (response && response.data) {
          setFormData({
            ...response.data,
            characteristics: response.data.characteristics || [], // Ensure it's an array
          });
          setIsViewMode(true);
        } else {
          console.log("No data found for this ID!");
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false); // Stop loading regardless of success or failure
      }
    }
  };

useEffect(() => {
  fetchData();
}, [id]);
 
  return (
    <>  
{ loading?<Loader/>:( 
   
  <div className="max-w-screen-xl poppins-bold mx-auto p-8">
      {/* Logo */}
      <div className="flex flex-col lg:flex-row items-start lg:items-center border-b border-[#16bab1]">
        <img
          src={logo}
          alt="Logo"
          className="h-56 w-72 object-contain mx-auto lg:mx-0"
        />
        <div className="flex flex-col w-full lg:ml-8">
          <h1 className="text-[#16bab1]xl text-[#16bab1] font-semibold mb-4 text-[#16bab1]enter lg:text-left">
            Admission Form
          </h1>
          <div className="flex flex-col lg:flex-row lg:space-x-8">
            <div className="mt-2 w-full lg:w-auto">
              <label
                htmlFor="date"
                className="block text-sm font-medium text-gray-700"
              >
                Date of Admission:
              </label>
              <input
                type="date"
                id="date"
                value={formData.dateOfAdmission}
                className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    dateOfAdmission: e.target.value,
                  }))
                }
              />
            </div>
            
            <div className="mt-4 mb-3 lg:mt-2 w-full lg:w-auto">
              <label
                htmlFor="admission"
                className="block text-sm font-medium text-gray-700"
              >
                Admission For:
              </label>
              <div className="flex flex-wrap gap-4 mt-2">
                {options.map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, admissionFor: option }))
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.admissionFor === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-4 mb-3 lg:mt-2 w-full lg:w-auto">
              <label
                htmlFor="academicYear"
                className="block text-sm font-medium text-gray-700"
              >
                Academic Year: <span className="text-red-500">*</span>
              </label>
              <div className="flex flex-wrap gap-4 mt-2">
                {generateAcademicYears().map((year) => (
                  <div
                    key={year}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, academicYear: year }))
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.academicYear === year
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {year}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Steps */}
      <div className="mb-8 mt-5">
  <div className="flex md:flex-nowrap flex-wrap justify-between">
    {steps.map((step, index) => (
      <div
        key={index}
        className={`w-full text-[#16bab1]enter py-2 border-b-4 cursor-pointer ${
          currentStep === index ? "border-[#16bab1]" : "border-gray-300"
        }`}
        onClick={() => setCurrentStep(index)} // Update currentStep on click
      >
        {step}
      </div>
    ))}
  </div>
</div>

      {/* Form Content */}
      <div className="border border-gray-300 p-6 rounded-lg">
        {renderStepContent()}

        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row justify-between mt-8">
          <button
            onClick={handlePrevious}
            className={`px-4 py-2 rounded text-black border border-[#16bab1] ${
              currentStep === 0 && "cursor-not-allowed"
            }`}
            disabled={currentStep === 0}
          >
            Previous
          </button>
          {currentStep < steps.length - 1 ? (
            <button
              onClick={handleNext}
              className="px-4 py-2 rounded bg-[#16bab1] text-white mt-4 sm:mt-0"
            >
              Next
            </button>
          ) : (
            <>
     {!isViewMode ? (
  <button 
    className="px-4 py-2 rounded bg-[#16bab1] text-white mt-4 sm:mt-0"
    onClick={handleSubmit}
    disabled={loading} // Disable button when loading
  >
    {loading ? "Submitting..." : "Submit"} {/* Change button text based on loading state */}
  </button>
) : (
  <button 
    className={`px-4 py-2 rounded ${userRole === "admin" ? "" : "hidden"} bg-[#16bab1] text-white mt-4 sm:mt-0`}
    onClick={handleSubmit}
    disabled={loading} // Disable button when loading
  >
    {loading ? "Updating..." : "Update"} {/* Change button text based on loading state */}
  </button>
)}

{/* {isViewMode && (
  <button
    onClick={() => handleOverAllView(id)} // Pass the id directly
    className="px-4 py-2 rounded bg-[#16bab1] text-white mt-4 sm:mt-0"
  >
    Overall View
  </button>
)}  */}
            </>
           
          )}
          {dialog.show && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded shadow-lg text-[#16bab1]enter w-[90%] max-w-sm">
                {dialog.type === "success" ? (
                  <MdCheckCircle
                    className="text-green-500 mx-auto mb-3"
                    size={48}
                  />
                ) : (
                  <MdError className="text-red-500 mx-auto mb-3" size={48} />
                )}
                <p className="text-lg navbar-link font-semibold text-gray-800">
                  {dialog.message}
                </p>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>

  )}

    </>
  );
};

export default Form;
